import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Box, ButtonGroup, Loader as LoaderUI } from '@paygreen/paygreen-ui';
import {
    CancelButton,
    ModalForm,
    Message,
    DeleteButton,
    ValidateButton,
    SimpleActionButton,
    Loader,
} from '../../../components';

/**
 * @description - errorMessage from API, loader and cancel/validate buttons used in all matching product modals
 */
const ModalTransversalUX = ({
    errorMessage,
    isLoading,
    cancelCloseModal,
    hasDisabledMode,
    mode,
    deleteProduct,
    t,
}) => (
    <>
        {errorMessage && !hasDisabledMode && (
            <Message
                message={errorMessage}
                type="error"
                paddingLateral="sm"
                marginTop="md"
                marginBottom="xs"
                blockWidth="lg"
                hasStaticWidth={true}
            />
        )}

        {/* loader when updating and closing modal */}
        {isLoading && <Loader isLoading={isLoading} />}

        {!hasDisabledMode && (
            <ButtonGroup marginTop="sm">
                {mode === 'edit' ? (
                    <CancelButton
                        buttonSize="md"
                        onClick={() => cancelCloseModal()}
                    >
                        {t('form.button.cancel')}
                    </CancelButton>
                ) : (
                    <SimpleActionButton
                        buttonSize="md"
                        icon="ArrowRoundTopLeftIcon"
                        onClick={() => cancelCloseModal()}
                    >
                        {t('form.button.cancel')}
                    </SimpleActionButton>
                )}

                {mode === 'edit' ? (
                    <ValidateButton
                        buttonSize="md"
                        isDisabled={isLoading}
                        type="submit"
                    >
                        {t('resetPassword.validateButton')}
                    </ValidateButton>
                ) : (
                    <DeleteButton
                        isDisabled={isLoading}
                        buttonSize="md"
                        onClick={() => deleteProduct()}
                        icon="TrashIcon"
                    >
                        {t('matching.deleteModal.deleteButton')}
                    </DeleteButton>
                )}
            </ButtonGroup>
        )}
    </>
);

const ProductModal = ({
    t,
    isOpen,
    isLoading,
    cancelCloseModal,
    errorMessage,
    children,
    modalTitle,
    blockWidth,
    mode,
    deleteProduct,
    hasDisabledMode,
}) => {
    return (
        <ModalForm
            modalTitle={modalTitle}
            blockWidth={blockWidth}
            paddingLateral="md"
            paddingBottom="md"
            hasCloseCross={true}
            isOpen={isOpen}
            actionOnClose={() => cancelCloseModal()}
        >
            {isLoading && hasDisabledMode ? ( // loader when opening the modal
                <Box margin="md">
                    <LoaderUI />
                </Box>
            ) : (
                React.Children.map(children, (child, index) => {
                    return React.cloneElement(
                        child,
                        {
                            key: index,
                        },
                        <ModalTransversalUX
                            isLoading={isLoading}
                            errorMessage={errorMessage}
                            hasDisabledMode={hasDisabledMode}
                            cancelCloseModal={cancelCloseModal}
                            deleteProduct={deleteProduct}
                            mode={mode}
                            t={t}
                        />,
                    );
                })
            )}
        </ModalForm>
    );
};
ProductModal.propTypes = {
    /**
     * @description setOpen and isOpen are automatically received from ModalControl parent
     */
    setOpen: PropTypes.func,
    isOpen: PropTypes.bool,
    cancelCloseModal: PropTypes.func.isRequired,
    errorMessage: PropTypes.string,
    modalTitle: PropTypes.string,
    blockWidth: PropTypes.string,
    hasDisabledMode: PropTypes.bool,
    isLoading: PropTypes.bool,
    mode: PropTypes.string,
    deleteProduct: PropTypes.func,
};

ProductModal.defaultProps = {
    blockWidth: 'md',
    hasDisabledMode: false,
    isLoading: false,
    mode: 'edit',
};

export default withTranslation('common')(ProductModal);
